import { Avatar } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import MemberDrawerSvg from "assets/icons/svg/memberIcon";
import ReturnSvgComponent from "assets/icons/svg/returnSvg";
import RightArrowSvg from "assets/icons/svg/RightArrowSvg";
import React, { useRef, useState } from "react";
import Select, { components } from "react-select";
import { HintField } from "..";
import { ReactComponent as MoneySVG } from "assets/icons/money-bag3.svg";
import TombSvgComponent from "assets/icons/svg/tomb";
import { ReactComponent as ContactAvatar } from "assets/icons/contact.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/settings.svg";
import { ReactComponent as PageIcon } from "assets/icons/page.svg";
import "./index.scss";
export const AsyncAutoCompleteField = ({
  handleInputChange,
  handleChange,
  touched,
  error,
  onOptionNewTab,
  onInputChange: onInputChangeProp,
  ...props
}) => {
  const isNewTabModeRef = useRef(false);
  const savedInputRef = useRef("");
  const selectRef = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = useState(undefined);
  const [inputValue, setInputValue] = useState(undefined);

  const formatOptionLabel = (option) => {
    const { name, id, profile_img, description, isClearRecentSearches } = option;
    if (isClearRecentSearches) {
      return <div className="dropdown-container dropdown-clear-recent">{name}</div>;
    }
    return (
      <div className="dropdown-container" key={id}>
        {profile_img === "finance" && <MoneySVG height={24} width={24} />}
        {profile_img === "account" && <MemberDrawerSvg fillcolor={"#2555ef"} />}
        {profile_img === "contact" && <ContactAvatar fillcolor={"#2555ef"} />}
        {profile_img === "deceased" && (
          <TombSvgComponent fillcolor={"#2555ef"} />
        )}
        {profile_img === "settings" && <SettingsIcon className="dropdown-settings-icon" width={22} height={22} />}
        {profile_img === "page" && <PageIcon className="dropdown-settings-icon" width={22} height={22} />}

        <div className="icon-name-container">
          <div className="name-container">
            <div>{name}</div>
            {id && <div className="id-container">#{id}</div>}
            {description && <div className="description-container">{description}</div>}
          </div>
        </div>
        {id && name && (
          <div className="return-icon">
            <ReturnSvgComponent width={24} height={24} />
          </div>
        )}
        {onOptionNewTab && name && !id && id !== "" && profile_img && (
          <div
            className="return-icon"
            title="Open in new tab"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              isNewTabModeRef.current = true;
              onOptionNewTab(option);
            }}
          >
            <OpenInNewIcon style={{ width: 18, height: 18, color: "white" }} />
          </div>
        )}
      </div>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    height: "48px",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
      ...props.style,
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#d9e4f6",
      },
    }),
    option: (styles) => {
      return {
        "&:hover": {
          cursor: "pointer",
        },
        ...styles,
      };
    },
    menu: (styles) => {
      return {
        ...styles,
      };
    },
    IndicatorSeparator: (styles) => ({ display: "none" }),
  };
  const DropdownIndicator = (innerProps) => {
    return (
      <components.DropdownIndicator {...innerProps}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  return (
    <div>
      <Select
        ref={selectRef}
        onInputChange={(text, { action }) => {
          if (action === "input-change") {
            savedInputRef.current = text;
            setInputValue(text);
            if (handleInputChange) handleInputChange(text);
            if (onInputChangeProp) onInputChangeProp(text);
          } else if (!isNewTabModeRef.current) {
            setInputValue(undefined);
            if (handleInputChange) handleInputChange(text);
            if (onInputChangeProp) onInputChangeProp(text);
          } else {
            // Tab-switch blur in new-tab mode: restore saved text and re-focus so input shows it
            setInputValue(savedInputRef.current);
            setTimeout(() => {
              if (selectRef.current) selectRef.current.focus();
            }, 50);
          }
        }}
        inputValue={inputValue !== undefined ? inputValue : undefined}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => {
          if (isNewTabModeRef.current) {
            isNewTabModeRef.current = false;
            return;
          }
          setMenuIsOpen(undefined);
          setInputValue(undefined);
        }}
        formatOptionLabel={formatOptionLabel}
        styles={colourStyles}
        onChange={(e) => {
          if (isNewTabModeRef.current) return;
          handleChange(e);
        }}
        components={{ DropdownIndicator }}
        {...props}
      />
      {touched && error ? <HintField error={error} /> : null}
    </div>
  );
};
